import { createContext, useContext, useState, ReactNode } from 'react';

interface Service {
  _id: string;
  name: string;
  slug: string;
  shortDescription?: string;
  description?: string;
  icon?: string;
  type: 'service' | 'solution' | 'academy';
  isActive?: boolean;
  isFeatured?: boolean;
  order?: number;
  parentId?: string | null;
}

interface ServicesContextType {
  services: Service[];
  solutions: Service[];
  academy: Service | null;
  setServicesData: (services: Service[], solutions: Service[], academy: Service | null) => void;
}

const ServicesContext = createContext<ServicesContextType>({
  services: [],
  solutions: [],
  academy: null,
  setServicesData: () => {}
});

export const useServices = () => {
  const context = useContext(ServicesContext);
  return context;
};

interface ServicesProviderProps {
  children: ReactNode;
}

export const ServicesProvider = ({ children }: ServicesProviderProps) => {
  const [services, setServices] = useState<Service[]>([]);
  const [solutions, setSolutions] = useState<Service[]>([]);
  const [academy, setAcademy] = useState<Service | null>(null);

  const setServicesData = (servicesData: Service[], solutionsData: Service[], academyData: Service | null) => {
    setServices(servicesData);
    setSolutions(solutionsData);
    setAcademy(academyData);
  };

  return (
    <ServicesContext.Provider value={{ services, solutions, academy, setServicesData }}>
      {children}
    </ServicesContext.Provider>
  );
};
